module.exports = __webpack_public_path__ + "static/media/success.c47b1199.png";